import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IOcbFileTransferInfo } from '@app/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-file-transfer-info-picker',
    templateUrl: './file-transfer-info-picker.component.html',
    styleUrls: ['./file-transfer-info-picker.component.scss'],
})
export class FileTransferInfoPickerComponent implements AfterViewInit {
    @Input()
    public fileTransfers: IOcbFileTransferInfo[];

    @Input()
    public isDisabled: boolean = false;

    @Input()
    public isRequired: boolean = false;

    @Input()
    public selectedItem: IOcbFileTransferInfo;

    @Output()
    public selectedItemChange = new EventEmitter<IOcbFileTransferInfo | null>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public ngAfterViewInit(): void {
        if (this.selectedItem) {
            this.selectBox.value = this.selectedItem.id;
        }
    }

    public onSelectedItemChange($event: IOcbFileTransferInfo): void {
        this.selectedItemChange.emit($event);
    }
}
